var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid-wrapper"},[_c('MainGrid',_vm._l((_vm.articles),function(ref){
var title = ref.title;
var image = ref.image;
var id = ref.id;
var slug = ref.slug;
var tags = ref.tags;
return _c('MainGridItem',{key:id,attrs:{"articlesTitle":title,"articlesImage":image,"subTitle":tags,"person":slug}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }